/**
 * Contents of `EgenBalans/LÄS MIG.txt`, written once when the root folder is
 * created. Plain Swedish for the person who opens the folder in Drive.
 */
export const README_FILE_NAME = 'LÄS MIG.txt';

/** The drive.file honesty paragraph; also shown under Mer › Lagring › Google Drive › "Vad appen kan se". */
export const DRIVE_VISIBILITY_TEXT =
  'Filer som du lägger i mappen på annat sätt, t.ex. med Google Drive-appens skanner, kan appen inte se – ' +
  'den har bara rätt till filer den själv skapat. Använd Kvittokameran, dela bilden till appen (Android), ' +
  'eller hämta filerna med knappen nedan.';

export const README_TEXT = `EgenBalans – din bokföring i Google Drive
===========================================

Den här mappen skapas och sköts av EgenBalans. Allt här är din
räkenskapsinformation enligt bokföringslagen (7 kap.) och ska sparas i
sju år efter utgången av det kalenderår då räkenskapsåret avslutades. Ta inte bort något här.

Så är mappen uppbyggd
---------------------
EgenBalans/
  LÄS MIG.txt                      den här filen
  <Företagsnamn> (<org.nr>)/
    bokforing.json                 senaste säkerhetskopian av hela bokföringen
    Systemdokumentation.md         beskrivning av kontoplan, rutiner och arkiv
    arkiv/2026-03.json …           frysta månadskopior, skrivs aldrig över
    arkiv/bokforing-2026-slutlig.json  låst kopia när ett räkenskapsår stängts
    Inkorg/                        kvitton som väntar på att bokföras
    Kvitton/2026/                  bokförda kvitton, namngivna efter verifikationsnummer
                                   t.ex. "A12 2026-03-04 Clas Ohlson 625,00.jpg"
    Ej bokfört/2026/               privata eller överhoppade underlag (sparas ändå)
    Kontoutdrag/2026/              importerade kontoutdrag
    Bokslut/2026/                  SIE-fil, arkivutdrag och rapporter per år

Vad appen kan se
----------------
Appen har bara rätt att läsa och ändra filer som den själv har skapat
(Googles behörighet "drive.file"). ${DRIVE_VISIBILITY_TEXT.replace(' med knappen nedan', ' via appen (Mer › Lagring › Google Drive)')}

Kvitton från mobilen
--------------------
Öppna appen på datorn, visa QR-koden och fota kvitton med mobilen. Bilderna
sparas i Inkorg/ och bokförs nästa gång du öppnar appen på datorn.

Återställa
----------
Öppna appen på en ny dator, välj "Återställ från lagring", Google Drive, och
peka på bokforing.json. Återställningen skapar alltid ett nytt lokalt företag och
skriver aldrig över bokföring som redan finns.

Lagringsplats
-------------
Bokföringen sparas på datorn och molnlagringen används för säkerhetskopiering.
Om arkivet förvaras utomlands gäller särskilda villkor för plats, anmälan
eller tillstånd och åtkomst. Läs mer under Mer › Lagring.
En fullständig ZIP-säkerhetskopia där innehåller också kvitton och andra
bilagor. HTML-rapporter och SIE-filer är exporter utan bilagor.
`;
